import styled from 'styled-components';
import theme from '../../utils/theme';
import { Link } from 'react-router-dom';

const FooterDiv = styled.div`
  padding-top: 40px !important;
  background: white;
`;

const Background = styled.div`
  background: ${theme.navbarBg};
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Derechos = styled.p`
  color: white;
  font-size: 17px;
  font-family: "Raleway", sans-seriff;
  max-width: 90%;
  text-align: center;
`;

const Aviso = styled(Link)`
  text-decoration: none;
  color: white;
  transition: color 500ms;

  &:hover {
    color: ${theme.verde};
  }
`;

export {
  FooterDiv,
  Background,
  Derechos,
  Aviso
}